// removed by extract-text-webpack-plugin
module.exports = {"root":"_1yA79DnFQTKhl2iWCYcTvx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/tag-list.scss
// module id = 1280
// module chunks = 0